import { DASHBOARDS_STORAGE_KEY, REGION_DASHBOARDS_STORAGE_KEYS } from '../constants/dashboards';

type TSetLocalStorage = {
  key: string;
  data: unknown;
  keyData: string;
};

type TSetDashboardsLocalStorage = Omit<TSetLocalStorage, 'key'>;

export const setLocalStorage = ({ key, data, keyData }: TSetLocalStorage) => {
  const oldData = JSON.parse(localStorage.getItem(key) || '{}');
  const newData = {
    ...oldData,
    [keyData]: data,
  };
  localStorage.setItem(key, JSON.stringify(newData));
};

export const setDashboardsLocalStorage = ({ data, keyData }: TSetDashboardsLocalStorage) => {
  setLocalStorage({ key: DASHBOARDS_STORAGE_KEY, data, keyData });
};

export const setRegionDashboardsLocalStorage = ({ data, keyData }: TSetDashboardsLocalStorage) => {
  setLocalStorage({ key: REGION_DASHBOARDS_STORAGE_KEYS, data, keyData });
};

export const calculateDynamic = <T>(data: Array<T>, key: keyof T, oldKey: keyof T) => {
  return data.map((item: T) => ({ ...item, dynamic: Number(item[key]) - Number(item[oldKey]) }));
};
